/**
 * ESM source for Vite/Rollup/Metro (named static imports).
 * The CJS sibling (`chunkLoadError.cjs`) is auto-generated from this file —
 * edit HERE and run `npm run sync:jtest-cjs` to regenerate.
 * Jest imports the `.cjs` version; server and browser import this `.mjs`.
 */

const STALE_CHUNK_RELOAD_KEY = 'fcp_stale_chunk_reload';

export function isChunkLoadError(error) {
  if (!error) {
    return false;
  }
  const message = typeof error.message === 'string' ? error.message : String(error);
  return (
    (error.name === 'TypeError' || error.name === 'ChunkLoadError')
    && (
      message.includes('Failed to fetch dynamically imported module')
      || message.includes('Importing a module script failed')
      || message.includes('error loading dynamically imported module')
      || message.includes('Loading chunk')
      || message.includes('Loading CSS chunk')
    )
  );
}

export function tryReloadForStaleChunk() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    if (sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) {
      sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
      return false;
    }
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, '1');
  } catch {
    // sessionStorage blocked
  }
  window.location.reload();
  return true;
}

export function clearStaleChunkReloadGuard() {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(STALE_CHUNK_RELOAD_KEY);
  } catch {
    // ignore
  }
}
